import {
  Provider as TooltipProvider,
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from 'components/Tooltip'
import React from 'react'
import styled from 'styled-components'

export const TooltipWrapper: React.FC<
  {
    label: React.ReactNode
    children: React.ReactNode
    side?: 'left' | 'right' | 'top' | 'bottom'
    offset?: number
    style?: React.CSSProperties
  } & React.HTMLAttributes<HTMLDivElement>
> = ({ label, children, side = 'top', offset = 20, style }) => {
  const [isHovering, setIsHovering] = React.useState(false)

  const handleMouseEnter = () => setIsHovering(true)
  const handleMouseLeave = () => setIsHovering(false)

  return (
    <TooltipProvider delayDuration={0}>
      <Tooltip open={isHovering}>
        <TooltipTrigger asChild>
          <div
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
            style={style}>
            {children}
          </div>
        </TooltipTrigger>
        {label && (
          <StyledTooltipContent sideOffset={offset} side={side}>
            <p>{label}</p>
          </StyledTooltipContent>
        )}
      </Tooltip>
    </TooltipProvider>
  )
}

const StyledTooltipContent = styled(TooltipContent)`
  background-color: ${({ theme }) => theme.forecast.background1};
  color: ${({ theme }) => theme.forecast.text1};
  pointer-events: none;

  svg {
    fill: ${({ theme }) => theme.forecast.background1};
  }
`
